import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {PlayerProfile} from '../../../../../model/player-profile';
import {TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../../../shared/helper/dialog-helper';
import {CommonDateComponent} from '../../../../../../shared/common/common-date/common-date.component';
import {DialogButtonComponent} from '../../../../../../shared/common/dialog-button/dialog-button.component';
import {RestErrorHelper} from '../../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../../service/player-profile.service';
import {InfoTextComponent} from '../../../../../../shared/common/info-text/info-text.component';

@Component({
  selector: 'app-player-profile-edit-birthday',
  imports: [
    CommonDateComponent,
    DialogButtonComponent,
    InfoTextComponent
  ],
  templateUrl: './player-profile-edit-birthday.component.html',
  styleUrl: './player-profile-edit-birthday.component.scss'
})
export class PlayerProfileEditBirthdayComponent implements OnInit
{
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private restErrorHelper = inject(RestErrorHelper);
  public playerProfileService = inject(PlayerProfileService);

  @Output() onUpdatePlayerProfileValue = new EventEmitter<any>();

  playerProfile: PlayerProfile;
  birthday: Date;
  isSaving: boolean;

  public static openDialog(dialogService: DialogService, playerProfile: PlayerProfile, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileEditBirthdayComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('EDIT_BIRTHDAY'),
        width: DialogHelper.getDialogWidth(600),
        data: {playerProfile}
      }));
  }

  ngOnInit(): void
  {
    this.playerProfile = this.config.data.playerProfile;
    this.birthday = this.playerProfile?.birthday;
  }

  onOkClicked(): void
  {
    if (!this.birthday)
      return;

    this.isSaving = true;
    const body = {
      birthday: this.birthday
    };

    this.playerProfileService.updateProfileField(body, false).subscribe({
      next: data =>
      {
        console.log('Daten erfolgreich geändert', data);
        this.ref.close(this.birthday);
      },
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  onCancelClicked(): void
  {
    if (!this.isSaving)
      this.ref.close(false);
  }
}
